import { message } from '@tencent/spaui';
import md5 from 'md5';

message.config({ maxCount: 1 });

const requestInit: Record<string, RequestInit> = {
  development: {
    credentials: 'include',
    mode: 'cors',
  },
  production: {
    credentials: 'same-origin',
  },
};

const request = (url: string, info: RequestInit = {}, version?: string) => {
  const timestamp = `${Math.round(new Date().getTime() / 1000)}`;
  const sign = md5(timestamp);
  const v = version || 'v1';

  return fetch(`/isv_service/${v}${url}`, {
    ...requestInit[process.env.NODE_ENV],
    ...info,
    headers: {
      ...info?.headers,
      timestamp,
      sign,
    },
  })
    .then((res) => res.json())
    .catch((error) => {
      message.error('请求失败，请稍候再试');
      return Promise.reject(error);
    })
    .then((res) => {
      if (res.code === -100) {
        message.error('登录态失效，请重新登录');
        if (window.location.pathname !== '/') {
          window.location.replace('/');
        }
        return Promise.reject(res.msg);
      }
      // 用户当前身份无法获取此接口内容，且不提示
      if (res.code === 403) {
        return Promise.resolve({});
      }
      // 报错但返回 resolve
      if (res.code === 10005) {
        message.error(`${res.msg || res.message}`);
        return Promise.resolve({});
      }
      if (res.code === 1100) {
        message.warn({
          duration: 0,
          message: res.msg,
          closable: true,
        });
        return Promise.reject(res.msg);
      }
      if (res.code !== 0) {
        // const requestId = res.requestId || res.traceId;
        message.error(`${res.msg || res.message}`);
        return Promise.reject(res.msg);
      }
      return res.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const get = (url: string, version?: string) => request(url, {}, version);

export const post = (url: string, data: object = {}, version?: string) =>
  request(
    url,
    {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    },
    version
  );

export const put = (url: string, data: object = {}, version?: string) =>
  request(
    url,
    {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    },
    version
  );

export const deleteData = (url: string, data: object = {}, version?: string) =>
  request(
    url,
    {
      method: 'DELETE',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    },
    version
  );
